/* eslint-disable react/prop-types */ // TODO: add props
import { Component } from 'react';
import { Modal } from 'react-bootstrap';
import _ from 'lodash';

class ExamTextResponse extends Component {
  state = {
    showModal: false,
  };

  componentDidMount() {
    // Moved event to ExamGridResultSquare -> PopoverContent
  }

  close = () => {
    this.setState({
      showModal: false,
    });
  };

  open = () => {
    this.setState({
      showModal: true,
    });
  };

  render() {
    const text = _.truncate(this.props.children, 200);

    return (
      <div className="exam-text-response">
        <span className={this.props.className}>
          {text}
          {text.length < this.props.children.length ? (
            <a onClick={this.open}>view full answer</a>
          ) : null}
        </span>
        <Modal
          className="modal-au"
          show={this.state.showModal}
          onHide={this.close}
          title=" "
        >
          <Modal.Body>
            <b>{this.props.student.name} &#39;s answer:</b>
            <br />
            {this.props.children}
            {this.props.footer}
          </Modal.Body>
        </Modal>
      </div>
    );
  }
}

export default ExamTextResponse;
